<template>
  <transition
    name="cab-modal-fade"
    @after-enter="showContent = true"
  >
    <!-- <div
      class="cab-modal-backdrop"
      @click="showContent = false"
      @touchmove="prevent"
    > -->
    <div
      class="cab-modal-backdrop"
      @click="showContent = false"
    >
      <transition
        name="cab-sidebar"
        @after-leave="finishClose"
      >
        <div
          class="cab-modal"
          @click.stop
          v-if="showContent"
          
        >
          <header class="cab-modal-header">
            <slot name="header">
              Title2
            </slot>
          </header>
          <section class="cab-modal-body">
            <slot name="body">
              Body
            </slot>
          </section>
          <footer class="cab-modal-footer">
            <slot name="footer">
              <b-button
                class="btn btn-primary cabinet"
                @click="startClose"
              >
                Close
              </b-button>
            </slot>
          </footer>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SlideModal",
  data() {
    return {
      showContent: false
    };
  },
  methods: {
    startClose() {
      this.showContent = false;
    },
    finishClose() {
      this.$emit("close-modal");
    },
    prevent(event) {
      console.log("something happened");
      event.preventDefault();
      event.stopPropagation();
    },
    closeModalWithEsc(e) {
      if (e.keyCode === 27 && this.showContent) {
        this.showContent = false;
      }
    }
  },
  watch: {
    showContent: function(isOpen) {
      // removed as this caused problems with scrolling
      // if (isOpen) {
      //   document.documentElement.style.overflow = "hidden";
      // } else {
      //   document.documentElement.style.overflow = "auto";
      // }
    }
  },
  created() {
    document.addEventListener("keydown", this.closeModalWithEsc);
  },
  destroyed() {
    document.removeEventListener("keydown", this.closeModalWithEsc);
  }
};
</script>

<style scoped>
.cab-modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: black;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: stretch;
  z-index: 1039;
}

.cab-modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  width: 400px;
  /* height: 100vh; */
  height: 100%;
  background-color: white;
  z-index: 1040;
  -webkit-overflow-scrolling: touch;
  /* -webkit-overflow-scrolling: auto !important;
  overflow-y: auto !important; */
}

.cab-modal-header,
.cab-modal-footer {
  padding: 15px;
  display: flex;
  z-index: 1041;
}

.cab-modal-header {
  border-bottom: 1px solid #eeeeee;
  color: white;
  /* background-color: #50557d; */
  /* background-color: #2c3e50; */
  /* background-color: #161616; */
  background-color: #c42c00;
  justify-content: space-between;
  font-weight: bold;
  min-height: 80px; /* For safari */
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
}

.cab-modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
  /* position: -webkit-sticky;  */
  width:400px;
  position: fixed;
  bottom: 0;
  background: white;
}

.cab-modal-body {
  position: relative;
  flex-grow: 1;
  padding: 15px;

  /* -webkit-overflow-scrolling: auto !important; */
  /* overflow-y: auto !important; */
  /* -webkit-overflow-scrolling: touch; */
  margin-bottom: 50px; /* since bottom bar is fixed */
}

.cab-btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

.cab-modal-fade-enter,
.cab-modal-fade-leave-active {
  opacity: 0;
}

.cab-modal-fade-enter-active,
.cab-modal-fade-leave-active {
  transition: opacity 0.1s ease;
}

.cab-sidebar-enter-active,
.cab-sidebar-leave-active {
  transition: transform 0.2s;
}

.cab-sidebar-enter,
.cab-sidebar-leave-to {
  transform: translateX(200%);
}

.cab-sidebar-enter-to,
.cab-sidebar-leave {
  transform: translateX(0);
}

@media (max-width: 499px) {
  .cab-modal {
    width: 100vw;
  }

  .cab-modal-footer {
    width: 100vw;
  }

  .cab-modal-backdrop {
    background-color: rgba(0, 0, 0, 0);
  }
}
</style>